<template>
  <div class="row m-0">
    <transition name="fade">
      <add-contact v-if="isAdd" @close="closeContact" @save="saveContact"></add-contact>
    </transition>
    <div class="col-12 mb-3 p-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col p-0">
          <h4 class="mb-0">Compose Message</h4>
        </div>
      </div>
    </div>
    <div class="col-12 white_bg p-4">
      <div class="row m-0 mb-2 align-items-center">
        <div class="col-12 p-0">
          <b>Who do you want to receive this letter?</b> <span class="error_text ms-2" v-if="!selectedContactID">Required</span>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0 align-items-center">
            <div class="col p-0">
              <select class="form-control w-100" v-model="selectedContactID" @change="changeContact">
                <option :value="key" v-for="(contact, key) in activeContacts" :key="key">{{contact.firstname}} {{contact.lastname}}</option>
              </select>
            </div>
            <div class="col-auto pe-0 cursor text-end" @click="openContact">
              <div class="row m-0 align-items-center">
                <div class="col-auto p-0 medium mt-2">
                  <ios-add-circle-outline-icon />
                </div>
                <div class="col-auto p-0 ps-1 d-none d-md-inline-flex mt-1">
                  New Contact
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 mt-3">
          <b>Select type of message</b> <span class="error_text ms-2" v-if="!message.type">Required</span>
        </div>
        <div class="col-12 p-0">
          <select class="form-control w-100" v-model="message.type">
            <option value="heartfelt">Heartfelt messages</option>
            <option value="digital_account">Digital and social media account management</option>
            <option value="event">Event arrangements</option>
            <option value="policies">Policies and finance</option>
            <option value="legal">Legal documents</option>
            <option value="misc">Miscellaneous requests</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div class="col-12 p-0 mt-3">
          <b>Subject</b>
        </div>
        <div class="col-12 p-0">
          <input class="form-control" v-model="message.subject">
        </div>
        <div class="col-12 p-0 mt-3">
          <b>Message</b>
        </div>
        <div class="col-12 p-0">
          <textarea class="form-control" v-model="message.message" rows="5" :placeholder="placeholder"></textarea>
        </div>
        <div class="col-12 p-0 mt-3">
          <b>Upload Attachments</b>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-12 p-0">
              <!-- <label for="upload" class="mb-0"><b>Upload pdf document</b></label> -->
              <small id="limitHelp" class="form-text text-muted mb-1 mt-0">
                <span v-if="theUser.subscription && theUser.subscription.details.attachments.cap && theUser.subscription.details.attachments.cap !== 'Unlimited'">
                  Your subscription allows a maximum file size of {{convertB(theUser.subscription.details.attachments.cap).amount}} {{convertB(theUser.subscription.details.attachments.cap).type}}
                </span>
                <span v-else>
                  Large files can take long to upload, please try limit file size to 20mb.
                </span>
                <div class="lh-1 mb-2">
                  <em>Please ensure the mail server is capable of receiving messages of this size.</em>
                </div>
              </small>
            </div>
            <div class="col-12 p-0">
              <div class="row m-0">
                <div class="col-auto p-0">
                  <input type="file" class="form-control border-0" id="upload" @change="onFileChange" multiple>
                  <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 p-0">
              <small id="sizeHelp1" class="form-text error_text my-1" v-if="uploadErrors.length > 0">
                <div>
                  {{uploadErrors.length}} file<span v-if="uploadErrors.length === 1"> was</span><span v-if="uploadErrors.length !== 1">s were</span> too big to upload or you've reached your storage cap, please upgrade your subscription
                </div>
                <ul>
                  <li v-for="(file, key) in uploadErrors" :key="key">
                    {{file.name}} ({{convertB(file.size).amount}} {{convertB(file.size).type}})
                  </li>
                </ul>
              </small>
              <small id="sizeHelp" class="form-text text-muted my-1">{{uploads.length}} file<span v-if="uploads.length !== 1">s</span> uploaded</small>
              <div v-for="(upload, key) in uploads" :key="key">
                <span @click="remove(key)" class="cursor hover small">
                  <div class="row m-0 align-items-center ">
                    <div class="col-auto p-0">
                      <ios-checkmark-circle-outline-icon class="pt-1 text-success" />
                    </div>
                    <div class="col-auto mw-25 text-truncate">
                      {{upload.name}}
                    </div>
                    <div class="col-auto ps-0">
                      <small>({{convertB(upload.size).amount}} {{convertB(upload.size).type}})</small>
                    </div>
                    <div class="col-auto p-0">
                      <ios-close-circle-outline-icon class="pt-1" />
                    </div>
                    <div class="col-auto d-none d-sm-block p-0">
                      Click to remove
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 mt-4">
        <div class="col-12 p-0" v-if="message.type && selectedContactID">
          <input type="checkbox" v-model="message.notify"/> <b>Notify contact about message</b>
        </div>
      </div>
      <div class="row mx-0 justify-content-between align-items-end mt-4">
        <div class="col-sm-3 p-0 mb-3 mb-sm-0">
          <storage-usage :storage="temporaryTotalStorage"/>
        </div>
        <div class="col-sm-8 p-0">
          <div class="row">
            <div class="col-6">
              <button class="btn btn-secondary w-100" @click="close">Cancel</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary w-100" @click="save" :disabled="!message.type || !selectedContactID">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/utils/firebase'
import { mapGetters, mapActions } from 'vuex'
import StorageUsage from '../components/StorageUsage.vue'
export default {
  name: 'Compose',
  components: {
    'add-contact': () => import('../components/AddContactPopup.vue'),
    StorageUsage
  },
  data () {
    return {
      contact: {},
      selectedContactID: '',
      selectedContact: {},
      newContact: {},
      message: {},
      isAdd: false,
      isSelected: false,
      uploads: [],
      uploadErrors: [],
      isLoading: false,
      temporaryMessageStorage: 0
    }
  },
  computed: {
    ...mapGetters(['contacts', 'storageUsed', 'theUser']),
    activeContacts () {
      const obj = {}
      Object.entries(this.contacts).forEach(entry => {
        const [key, value] = entry
        if (!value.deleted) {
          obj[key] = value
        }
      })
      return obj
    },
    placeholder () {
      switch (this.message.type) {
        case 'heartfelt':
          return 'Send messages to individuals that are important to you. Include photographs you would want to share. Include a video message if you prefer.'
        case 'digital_account':
          return 'Provide login details to a trusted individual so that they can login to your social media accounts and access any important digital files on the cloud. Explain to them how you would like your social media accounts and files to be managed. Do you want some accounts closed or memorialised? Do you want some files deleted or transferred?'
        case 'event':
          return 'Provide details on how you would like your final event to be handled to a trusted individual. Would you prefer a burial or cremation? Would you prefer a traditional funeral or do you have something else in mind? Do you have any special requests, such as who you would prefer to give a eulogy, any specific music played at your event, or a specific venue in mind?'
        case 'policies':
          return 'Provide details or copies of your important insurance and health policies to your beneficiaries. Provide your banking and financial details to your loved ones. Remember your share portfolio and/or cryptocurrency details.'
        case 'legal':
          return 'Provide details of any pertinent legal documents. This may include your last will and testament, divorce settlements, deeds of ownership, etc.'
        case 'misc':
          return 'Do you have any specific possessions you would like to give to someone? Do you want to ask someone specific to look after your pets?'
        default:
          return ''
      }
    },
    temporaryTotalStorage () {
      const ret = this.storageUsed + this.temporaryMessageStorage
      return ret
    }
  },
  methods: {
    ...mapActions(['addMessage', 'getStorageUsed']),
    changeContact () {
      this.isSelected = true
      this.message.contactId = this.selectedContactID
    },
    onFileChange (e) {
      e.target.files.forEach(item => {
        this.isLoading = true
        console.log('item', item)
        this.temporaryMessageStorage += item.size
        if (this.temporaryTotalStorage > this.theUser.subscription.details.storage) {
          this.fileTooBig(item)
          this.temporaryMessageStorage += (-item.size)
        } else {
          if (this.theUser.subscription.details.attachments.cap && (item.size > this.theUser.subscription.details.attachments.cap)) {
            this.fileTooBig(item)
            this.temporaryMessageStorage += (-item.size)
          } else {
            var file = item
            const fileName = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
            uploadFile(fileName, file, this.fileUploaded)
          }
        }
      })
    },
    fileUploaded (url, file, path, size) {
      this.uploads.push({ url: url, name: file, path: path, size: size })
      this.message.uploads = this.uploads
      this.getStorageUsed()
      this.isLoading = false
    },
    fileTooBig (file) {
      this.uploadErrors.push(file)
      this.isLoading = false
    },
    remove (val) {
      this.message.uploads.splice(val, 1)
      this.setTemporaryMessageStorage()
    },
    close () {
      this.$router.push('messages')
    },
    save () {
      this.addMessage(this.message)
      this.$router.push('messages')
    },
    openContact () {
      this.isAdd = true
    },
    closeContact () {
      this.isAdd = false
    },
    saveContact (val) {
      this.isAdd = false
      this.selectedContact = val
      this.selectedContactID = val.id
      this.isSelected = true
      this.message.contactId = this.selectedContactID
    },
    convertB (val) {
      var data = {
        amount: 0,
        type: null
      }
      // return Math.round(BtoGB * 100) / 100
      const BtoGB = val / 1000000000
      const BtoMB = val / 1000000
      const BtoKB = val / 1000
      if (val > 999999999) {
        data.amount = Math.round(BtoGB * 100) / 100
        data.type = 'GB'
        return data
      } else if (val > 999999) {
        data.amount = Math.round(BtoMB * 100) / 100
        data.type = 'MB'
        return data
      } else {
        data.amount = Math.round(BtoKB * 100) / 100
        data.type = 'KB'
        return data
      }
    },
    setTemporaryMessageStorage () {
      var messageStorage = 0
      this.uploads.forEach(file => {
        messageStorage += file.size
      })
      this.temporaryMessageStorage = messageStorage
    }
  }
}
</script>

<style scoped>
input[type="file" i]::-webkit-file-upload-button {
  display: inline-flex;
}
.mw-25 {
  max-width: 25vw !important;
}
</style>
